module.exports = __webpack_public_path__ + "static/media/check-box-brown.f79e9dd9.png";